import React from "react";
import { Activity, OfflineMode } from "@api/graphql/generated/generated-types";
import { Badge } from "@src/common/components";
import { ActivityIcon } from "../utils/activityIcon";
import { ActivityChangeDetailView } from "./ActivityChangeDetail";
import { getActivityUpdater } from "../utils/getActivityUpdater";
import moment from "moment";

interface ActivityItemProps {
  activity: Activity;
}

export function ActivityItem({ activity }: ActivityItemProps) {
  const updater = getActivityUpdater(activity);
  return (
    <div className="flex items-start gap-2 py-2">
      <div className="mt-1">
        <ActivityIcon infoType={activity.infoType} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm text-gray-900 dark:text-gray-100 truncate">
          {activity.description}
        </div>
        <div className="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400 mt-0.5">
          <span>{moment(activity.time * 1000).format("LT")}</span>
          {updater && (
            <span className="font-mono text-gray-400 dark:text-gray-500">
              {updater}
            </span>
          )}
        </div>
        {activity.offlineMode === OfflineMode.Offline && (
          <div className="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400 mt-1">
            <Badge color="warning" size="xs" className="inline-block w-fit">
              OFFLINE
            </Badge>
            {/* `time` above is the driver's tap-time; createdAt is when the
                replay reached the server after reconnect. */}
            <span className="whitespace-nowrap">
              Recorded at {moment(activity.createdAt * 1000).format("LT")}
            </span>
          </div>
        )}
        {activity.imageUrl && (
          <div className="w-full max-h-[500px] overflow-hidden mt-2">
            {/* Next js doesn't support dynamic height of image based on the aspect ratio, so disable eslint rule */}
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={activity.imageUrl}
              alt=""
              className="w-full h-auto rounded max-h-[500px] object-contain"
            />
          </div>
        )}
        {activity.change && (
          <ActivityChangeDetailView change={activity.change} />
        )}
      </div>
    </div>
  );
}
